import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useStrategyBreakdown(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "strategy-breakdown", filters],
    queryFn: async () => {
      const { data, error } = await client.GET(
        "/api/analytics/strategy-breakdown",
        { params: { query: toAnalyticsQuery(filters) } },
      );
      if (error !== undefined) {
        throw new Error("Failed to load strategy breakdown");
      }
      return data;
    },
  });
}
